export default "__VITE_ASSET__DAnjdoNV__"